import { render } from "./LoadingBlock.vue?vue&type=template&id=e279bcd0&scoped=true&ts=true"
import script from "./LoadingBlock.vue?vue&type=script&lang=ts"
export * from "./LoadingBlock.vue?vue&type=script&lang=ts"

import "./LoadingBlock.vue?vue&type=style&index=0&id=e279bcd0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e279bcd0"]])

export default __exports__